/// <amd-module name="typeahead/core/message/TypeaheadMessage" />

/// <amd-dependency path="uitk" name="uitk"/>

/// <reference path="../../../typings/typeahead/uitk.d.ts" />

export abstract class TypeaheadMessage {

    public static publish<T extends TypeaheadMessage>(msg: T): void {
        uitk.publish(msg.getTopic(), msg);
    }

    public static subscribe<T>(topic: string, handler: (topic: string, message: T) => void): string {
        return uitk.subscribe(topic, handler);
    }

    public static unsubscribe<T>(topic: string, token: string): void {
        return uitk.unsubscribe(topic, token);
    }

    public abstract getTopic(): string;

}
